export const PRERENDER_CHECKOUT_ROOT_ID = 'js-prerender-checkout-root';
export const AB_TEST_NAME_PRERENDER_CHECKOUT = 'checkout-pre-render-v2';
export const AB_TEST_VARIANT_NAME_PRERENDER_CHECKOUT = 'variant';
